import { FieldActions, ActionUtils, PasswordField as FrontEndField } from 'core.frontend';
import { h, JSX } from 'preact'
import ObservingComponent from '../componentBases/observingComponent';
import FieldIcon from './fieldIcon';
import Button from '../buttons/button';

export interface PasswordFieldProps {
    id?: string;
    field: FrontEndField;
    labelClassName?: string;
    className?: string;
    leftIcon?: string;
    stopPropagation?: boolean;
}

class PasswordField extends ObservingComponent<PasswordFieldProps> {

    public componentWillMount(): void {
        const { field } = this.props;

        this.registerUpdateObserver(field.observationProvider, ActionUtils.actionsToArray(FieldActions, [FieldActions.Hidden, FieldActions.Shown]));
    }

    public valueChanged = (e: any) => {
        const { field } = this.props;
        const newValue = e.target.value;

        field.setValue(newValue);
    }

    public render({ field, labelClassName, className = '', leftIcon = '', id } : PasswordFieldProps): JSX.Element {

        if (!id) {
            id = field.uniqueKey;
        }

        return (
            <div className={`input-field ${className}`}>

                { leftIcon && <FieldIcon icon={leftIcon} invalid={field.isInvalid} />}

                <label
                    className={labelClassName}
                    for={id}>

                    <span class="fill">
                        {field.label}
                    </span>

                    { field.errorMessage && (
                        <span className="invalid">{field.errorMessage}</span>
                    )}
                </label>

                <input
                    type={field.showPassword ? "text" : "password"}
                    id={id}
                    name={field.uniqueKey}
                    onFocus={field.focus}
                    onBlur={field.blur}
                    value={field.value}
                    onChange={this.valueChanged}
                    className={field.isInvalid ? 'invalid' : ''}
                    disabled={field.isDisabled} />

                <Button
                    className="btn-icon btn-show-password"
                    button={field.showPasswordButton} />
            </div>
        );
    }
}

export default PasswordField;
